<template>
  <div class="box">
    <div class="box__header">
      <h3>Общая информация</h3>

      <div class="buttons">
        <ReclamationExternalSpringReceived
          v-if="$store.getters['permission/permissionUpdateReclamationSpringReceived'] && reclamation.canSpringReceived()"
          :reclamation="reclamation"
        />

        <VTooltip
          popupText="Сохраните изменения в форме «Решение»"
          :showTip="hasTooltip"
          tooltipSide="top"
          style="width: 100%"
        >
          <VButton
            v-if="visibleEditBtn"
            text="Редактировать"
            :class="(isEdit || isDisableEdit) && 'disabled filter-gray'"
            size="sm"
            icon="edit"
            @click.native="openEditForm"
          />
        </VTooltip>
      </div>
    </div>

    <ReclamationExternalCardDetails
      v-if="!isEdit"
      :reclamation="reclamation"
    />

    <ReclamationExternalEditForm
      v-else
      :reclamation="reclamation"
      @update-success="onUpdateSuccess"
      @update-modal="onUpdateModal"
      @cancel="closeEditForm"
    />
  </div>
</template>

<script>
import VButton from '@/components/simple/button/VButton.vue'
import { ReclamationExternalCardDetails, reclamationExternalModel } from '@/entities/reclamation-external'
import { ReclamationExternalEditForm } from '@/features/reclamation-external/edit'
import { ReclamationExternalSpringReceived } from '@/features/reclamation-external/spring-received'
import { mixinIsEdit } from '@/mixins/mixinIsEdit'
import { mapMutations, mapState } from 'vuex'
import { goToPage } from '@/utils/router'
import VTooltip from '@/components/ui/VTooltip.vue'

export default {
  components: {
    VTooltip,
    ReclamationExternalCardDetails,
    ReclamationExternalEditForm,
    VButton,
    ReclamationExternalSpringReceived
  },
  mixins: [mixinIsEdit],
  computed: {
    ...mapState('reclamationExternal/details', {
      reclamation: 'reclamation',
      isDisableEdit: 'isDisableEdit'
    }),
    visibleEditBtn () {
      return this.$store.getters['permission/permissionUpdateReclamationGeneralInformation'] || this.$store.getters['permission/permissionUpdateReclamationIndicator']
    },
    hasTooltip () {
      return this.isDisableEdit && !this.isEdit
    }
  },
  methods: {
    ...mapMutations('reclamationExternal/launchIntoProduction', {
      openModalLaunchIntoProduction: 'OPEN_MODAL'
    }),
    ...mapMutations('reclamationExternal/details', {
      SET_DISABLE_EDIT: 'SET_DISABLE_EDIT'
    }),

    goToReclamationList () {
      goToPage(this.$store.state.pages.reclamationPages.list, {
        status: reclamationExternalModel.STATUSES[0].value
      })
    },

    onUpdateSuccess () {
      this.turnOffIsEdit()
      this.SET_DISABLE_EDIT(false)

      if (!this.reclamation.isIndicatorForLaunchIntoProduction()) return

      if (!this.reclamation.hasReclamationOrder()) {
        return this.openModalLaunchIntoProduction('form')
      }
    },

    onUpdateModal () {
      return this.openModalLaunchIntoProduction('form')
    },

    openEditForm () {
      this.turnOnIsEdit()
      this.SET_DISABLE_EDIT(true)
    },

    closeEditForm () {
      this.turnOffIsEdit()
      this.SET_DISABLE_EDIT(false)
    }
  }
}
</script>
